import React from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';

// Legacy/shareable lien-waiver links are path-style: /contractor-portal/:token
// (generated by the owner "Copy portal link" button). The live signing portal
// is ContractorCompliancePortal at /contractor-compliance?token=... — this
// component maps the old path form to the query form so those links resolve
// instead of rendering a blank screen.
export default function ContractorPortalTokenRedirect() {
  const { token } = useParams();
  const location = useLocation();
  const existing = new URLSearchParams(location.search);
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  const phase = existing.get('phase') || existing.get('phase_id');
  if (phase) params.set('phase', phase);
  return <Navigate to={`/contractor-compliance?${params.toString()}`} replace />;
}
